/* ============================================================
   NZG BEWERTUNGS-BADGE (Judge.me)
   Erstellt: 2026-09-15

   <nzg-reviews-drawer> erbt x-drawer aus theme.js. Öffnen, Schließen,
   Overlay, Fokusfalle und html.lock liefert das Theme, das den Badge-Knopf
   über aria-controls selbst anbindet. Hier nur:
   - bis 999 px als Blatt von unten, wie Warenkorb und Treuepunkte
   - Inhalt beim ersten Öffnen über die Section Rendering API holen
     (sections/nzg-reviews-drawer.liquid), vorgewärmt, sobald Zeiger oder
     Fokus auf dem Badge landen
   - „Weitere Bewertungen anzeigen“
   Markup und Stile: snippets/nzg-reviews-badge.liquid
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'nzg-reviews-drawer';

  function sectionUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + '?section_id=' + SECTION_ID;
  }

  customElements.whenDefined('x-drawer').then(function () {
    if (customElements.get('nzg-reviews-drawer')) return;
    var DrawerBase = customElements.get('x-drawer');

    class NzgReviewsDrawer extends DrawerBase {
      get openFrom() {
        if (window.matchMedia('(max-width: 999px)').matches) return 'bottom';
        return this.getAttribute('open-from') || 'right';
      }

      connectedCallback() {
        super.connectedCallback();

        // Nur einmal binden. DialogElement schiebt die Schublade beim Öffnen
        // nach <body> und beim Schließen zurück, jeder Umzug ruft
        // connectedCallback erneut auf (gleiche Falle wie im Loyalty-Drawer).
        if (this._nzgBound) return;
        this._nzgBound = true;

        this.addEventListener('toggle', () => {
          if (this.open) this.load();
        });

        this.addEventListener('click', (event) => {
          var more = event.target.closest('[data-rd-more]');
          if (!more) return;
          this.querySelectorAll('[data-rd-extra]').forEach(function (el) { el.hidden = false; });
          more.hidden = true;
        });
      }

      load() {
        if (this._nzgState === 'loading' || this._nzgState === 'done') return;
        this._nzgState = 'loading';

        var loading = this.querySelector('[data-rd-loading]');
        var error = this.querySelector('[data-rd-error]');
        if (loading) loading.hidden = false;
        if (error) error.hidden = true;

        fetch(sectionUrl(), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then((html) => {
            var content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nzg-rd]');
            if (!content) throw new Error('Kein Inhalt');
            this.querySelector('[data-rd-body]').replaceChildren(document.importNode(content, true));
            this._nzgState = 'done';
          })
          .catch(() => {
            // Beim nächsten Öffnen erneut versuchen
            this._nzgState = 'error';
            if (loading) loading.hidden = true;
            if (error) error.hidden = false;
          });
      }
    }

    customElements.define('nzg-reviews-drawer', NzgReviewsDrawer);
  });

  /* Vorwärmen: Liste holen, sobald jemand das Badge anpeilt */
  function warm() {
    var drawer = document.getElementById('nzg-reviews-drawer');
    if (drawer && typeof drawer.load === 'function') drawer.load();
  }
  var badge = document.querySelector('.nzg-rbadge');
  if (badge) {
    badge.addEventListener('pointerenter', warm, { once: true });
    badge.addEventListener('focus', warm, { once: true });
  }

  /* Dem Footer ausweichen: Sobald der Footer ins Bild kommt, läge das Badge über
     Footer-Links, am Handy auch über dem Widerrufsbutton (§ 356a BGB). Der Footer ist
     das letzte Element der Seite, „im Bild“ heißt also: unten, genau wo das Badge sitzt. */
  var footer = document.querySelector('.footer');
  if (badge && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      badge.classList.toggle('nzg-rbadge--footer', entries[0].isIntersecting);
    }).observe(footer);
  }
})();
